/* Copyright (c) 2017 Backpack Health LLC */
/* global window */

import React from 'react';
import PropTypes from 'prop-types';
import MessageDialog from './MessageDialog';
import AppUtils from '../../../utilities/AppUtils';

const LogoutConfirmMessageDialog = (props) => (
  <MessageDialog
    title={{
      id: 'logout.confirm.title.text',
    }}
    message={{
      id: 'logout.confirm.message.text',
    }}
    buttons={[
      {
        text: {
          id: 'nav.cancel.button.label',
        },
        onClick: props.onCancel,
      },
      {
        text: {
          id: 'nav.OK.button.label',
        },
        onClick: () => {
          AppUtils.logout({}, () => {
            window.history.replaceState(null, null, '');
            AppUtils.reloadApp();
          });
        },
      },
    ]}
  />
);
LogoutConfirmMessageDialog.propTypes = {
  onCancel: PropTypes.func.isRequired,
};

export default LogoutConfirmMessageDialog;
